import { Link } from "react-router-dom";
import Utils from "../../../Common/Utils";
import React from "react";
import Label from "../../Common/components/Label";
import DeltaTable from "Components/Common/DeltaTable";
import AccordionLayout from "Components/Common/components/Accordion/AccordionLayout";
import AccordionHeader from "Components/Common/components/Accordion/AccordionHeader";
import AccordionBody from "Components/Common/components/Accordion/AccordionBody";

const LocalLink = ({href, value}) => (
  <Link
    to={href}
    className="tw-cursor-pointer"
  >
    {value}
  </Link>
)

const ProductsTableViewSearch = ({ res }) => {
  function getRules() {
    let entity = res.data.result.filter(
      (result) => result.entity === "CompatioRule"
    );
    if (entity.length > 0) {
      return entity[0].data;
    }
    return [];
  }

  function getCategory() {
    let entity = res.data.result.filter(
      (result) => result.entity === "Category"
    );
    if (entity.length > 0) {
      return entity[0].data;
    }
    return [];
  }

  function getCategoryType() {
    let entity = res.data.result.filter(
      (result) => result.entity === "CategoryType"
    );
    if (entity.length > 0) {
      return entity[0].data;
    }
    return [];
  }

  function geAttributes() {
    let attributeEntity = res.data.result.filter(
      (result) => result.entity === "Attribute"
    );
    if (attributeEntity.length > 0) {
      return attributeEntity[0].data;
    }
    return [];
  }

  function getCategories() {
    let productsEntity = res.data.result.filter(
      (result) => result.entity === "Product"
    );
    if (productsEntity.length > 0) {
      return productsEntity[0].data;
    }
    return [];
  }

  function getProductAttributes(data) {
    let attributes = [];
    // attributes.push("Name/Id");
    data["product"].forEach(function (product) {
      product["attr_vals"].forEach(function (attributeVal) {
        attributes.push(attributeVal["attr_name"]);
      });
    });
    return [...new Set(attributes)];
  }

  function getProducts(data) {
    let products = [];
    data["product"].forEach(function (product) {
      // join attribute values
      const attrs = product.attr_vals?.reduce((acc, attr) => {
        const {attr_name, attr_value} = attr
        return {...acc, [attr_name]: attr_value.map((it) => it.value).join(', ')}
      }, {})
      products.push({...product, ...attrs});
    });
    return products
  }


  const truncate = (input, stringLength) => {
    try {
    } catch (e) { }
    if (Utils.isUndefinedOrNull(input)) return "-";
    return input.length > stringLength
      ? `${input.toString().substring(0, stringLength)}...`
      : input;
  };

  const tableOptions = {
    disableSort: true,
    disableHeaderControls: true,
    disableRowOptions: true,
    striped: true,
    footer: false    
  }
  const products =  getCategories().map((categoryData) => {
    return {
      label: "Products - " + categoryData["category"],
      data: getProducts(categoryData),
      columns: [{name: "Name/Id", column: "name", options: {callbackComponent: (item) => <LocalLink href={`/gms/product/details/${item.id}`} value={truncate(item["name"], 43)}/>}}, 
        ...Utils.generateHeadersFromArray(getProductAttributes(categoryData))
      ],
      tableOptions: {...tableOptions, pagination: "manual", footer: true}
    }
  })

  const dataTypes = [
    {label: "Category", data: getCategory(), columns: [{name: "Name/Id", column: "name", options: {callbackComponent: (item) => <LocalLink href={`/gms/taxonomy/category/c/${item["id"]}`} value={truncate(item["name"], 43)}/>}}]},
    {label: "Category Type", data: getCategoryType(), columns: [{name: "Name/Id", column: "name", options: {callbackComponent: (item) => <LocalLink href={`/gms/taxonomy/category/ct/${item["id"]}`} value={truncate(item["name"], 43)}/>}}]},
    ...products,
    {label: "Attributes", data: geAttributes(), columns: [{name: "Name", column: "name", options: {
      callbackComponent: (item) =>  <LocalLink href={`/gms/taxonomy/attribute/${item["id"]}`} value={truncate(item["name"], 43)}/>
      }}, {name: "Value", column: "value"}]},
    {label: "Rules", data: getRules(), columns: [
      {name: "Name", column: "name", options: {
        callbackComponent: (item) => <LocalLink href={`/gms/rule/edit/${truncate(item["uid"])}`} value={truncate(item["name"], 43)}/>
      }}, 
      {name: "Category 1", column: "left_category_name"},
      {name: "Category 2", column: "right_category_name"},
      {name: "Type", column: "rule_type"},
      {name: "Status", column: "rule_status", options: {callbackComponent: (item) => item["rule_status"] !== 0 ? "Active" : "InActive"}},
      {name: "Effective Date", column: "updated_on"}
    ]},
  ]
  return (
      <div>
        {
          dataTypes.map((type, index) => {
            if (!type.data || type.data?.length < 1) return <></>
            return (
              <AccordionLayout key={type.label}>
              {(provided) => (
              <div className="rounded tw-border-b tw-border-r tw-border-l tw-mb-5">
                  <AccordionHeader {...provided.getHeaderProps()} options={{arrowPosition: "left"}}>
                    <span className="tw-px-3">
                      <Label
                        message = {`${type.label} (${type.data.length})`}
                        fontSize={0.8}
                      />
                    </span>
                  </AccordionHeader>
              
                  <AccordionBody {...provided.getBodyProps()}>
                    <DeltaTable
                      columns = {type.columns}
                      data = {type.data}
                      options={type.tableOptions ?? tableOptions}
                      totalRecords={type.data.length}
                      />
                  </AccordionBody> 
                </div>
              )}
              </AccordionLayout>
            )
          })
        }
      </div>
  );
};
export default ProductsTableViewSearch;
